import { TokenData, UserData } from '../types';
import { baseClient } from './client/instance';

const path = 'user';

export const getCurrentUser = async () => {
  const response = await baseClient.post<UserData>(`${path}/me`);
  return response.data;
};

export const getTokens = async () => {
  const response = await baseClient.get<TokenData>(`${path}/token`);
  return response.data;
};

export const deleteUser = async () => {
  const response = await baseClient.delete(path);
  return response.data;
};

export const setFirstLogin = async () => {
  await baseClient.post(`${path}/set_first_login`);
};

export const completeUnboarding = async () => {
  await baseClient.post(`${path}/complete_onboarding`);
};
